// src/locale-config.ts
var customLocales = null;
function setCustomLocaleConfig(appLocales) {
  if (!appLocales)
    throw new Error("You must provide a locale config.");
  customLocales = appLocales;
}
function getCustomLocaleConfig() {
  return customLocales;
}
export {
  getCustomLocaleConfig,
  setCustomLocaleConfig
};
//# sourceMappingURL=index.js.map